import { apiGet, apiPost } from './api';

export interface Character {
  characterIdx: number;
  name: string;
  lev: number;
  style: number;       // class ID (1-9) — campo legado
  class: number;       // class ID da API real
  nation: number;      // 0=none, 1=Capella, 2=Procyon
  alz: number;
  wExp: number;        // war exp / honors
  str: number;
  dex: number;
  int: number;
  pnt: number;
  [key: string]: any;
}

/** GET /Character/get — lista de personagens da conta */
export const getCharacters = () => apiGet<Character[]>('/Character/get');

/** GET /Character/nation — mudar nacao */
export const updateNation = (characterIdx: number, nation: number) =>
  apiGet<{ status: string; message: string }>('/Character/nation', { characterIdx, nation });

/** GET /Character/pk — limpa PK de TODOS os chars offline da conta (sem charIdx) */
export const removePk = () =>
  apiGet<{ status: string; message: string }>('/Character/pk');

/** GET /Character/delete — deletar personagem */
export const deleteCharacter = (characterIdx: number) =>
  apiGet<{ status: string; message: string }>('/Character/delete', { characterIdx });

/** POST /Character/points — redistribuir pontos */
export const updatePoints = (body: { characterIdx: number; str: number; dex: number; int: number; pnt: number }) =>
  apiPost<{ status: string; message: string }>('/Character/points', body);
